import script from "./Sources.vue?vue&type=script&setup=true&lang=js"
export * from "./Sources.vue?vue&type=script&setup=true&lang=js"

import "./Sources.vue?vue&type=style&index=0&id=1cff6baa&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cff6baa"]])

export default __exports__